export enum PlatformIds {
  loc = 20,
  dev = 2824,
  com = 1,
}
